import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Connects to data-controller="option-select"
export default class extends Controller {
  static targets = ["parent", "child"];
  static values = { url: String };

  async initialize() {
    const { default: Choices } = await import("choices.js");

    new Choices(this.parentTarget, {
      noResultsText: "Nenašla sa žiadna zhoda..",
    });

    const childChoices = new Choices(this.childTarget, {
      noResultsText: "Nenašla sa žiadna zhoda..",
      noChoicesText: "Vyber hodnotu vyššie..",
    });

    this.parentTarget.addEventListener("change", async (event) => {
      const selectedOptionTypeId = event.target.value;
      const url = this.urlValue;

      if (selectedOptionTypeId) {
        const response = await get(url, {
          query: {
            option_type_id: selectedOptionTypeId,
          },
          responseKind: "json",
        });

        if (response.ok) {
          const body = await response.json;

          childChoices.setChoices(body, "value", "label", true, true, true);
        }
      } else {
        childChoices.clearChoices(true, true);
      }
    });
  }
}
